$(function() {

    $document = $(document);

    $document.foundation();

    // content tabs

    $document.on('click', '.content-tab-title', function(e) {
        e.preventDefault();
        var $trigger = $(this);
        $('.content-tab').fadeOut();
        $(".content-tab").promise().done(function() {
            var href = $trigger.attr('href');
            $('.content-tab-title').removeClass('active');
            $trigger.addClass('active');
            $(href).fadeIn();
        });

    });

    // search overlay trigger

    $document.on('click','#searchLink', function(e) {
        e.preventDefault();
        $('#overlay-search-input').focus();
    });

    // details overlay trigger

    $document.on('click', 'a.detailslightbox', function(e) {
        e.preventDefault();
        var detailsId = $(this).attr('href');
        var html = $(detailsId).html();
        $('#overlayDetailsContent').html(html);
        $('#overlayDetails').foundation('open');
    });

    // lightbox overlay trigger

    $document.on('click', 'a.lightbox', function(e) {
        if (window.innerWidth > 1024) {
            e.preventDefault();
            var url = $(this).attr('href');
            var filename = url.split('.').pop().toLowerCase();
            var imgclass = 'img-fluid';
            if (filename === 'svg') {
                imgclass += ' img-vector';
            }
            $('#overlayPreviewContent').css('background-image','url("'+url+'")');
            $('#overlayPreview').foundation('open');
        } else {
            e.preventDefault();
        }
    });

    // share overlay trigger

    $document.on('click', '.sharePopup .popup a', function(e) {
        if (window.innerWidth > 1024) {
            e.preventDefault();
            var url = $(this).attr('href');
            var newWindow = window.open(url, 'Share', 'scrollbars=yes, width=1024, height=660');
            if (window.focus) {
                newWindow.focus();
            }
        }
    });

    // scroll to anchor on click

    var href = location.protocol + '//' + location.host + location.pathname;

    $document.on('click', 'a[href^="#"],a[href^="'+href+'#"]', function(e) {
        if ($(this).hasClass('accordion-title') || $(this).hasClass('tab-title') || $(this).hasClass('content-tab-title')) {
            return;
        }
        var idsplit = $(this).attr('href').split('#')[1];
        if (idsplit.length > 0) {
            var $id = $('#'+idsplit);
            if ($id.length === 0) {
                return;
            }
            e.preventDefault();
            $('#offCanvas').foundation('close');
            var headerHeight = $('#header').height();
            var pos = $id.offset().top - headerHeight - 88;
            $('body, html').animate({scrollTop: pos}, 600);
        }
    });

    // scroll to anchor on load

    if (location.hash) {
        var $id = $(location.hash);
        if ($id.length) {
            var headerHeight = $('#header').height();
            var pos = $id.offset().top - headerHeight - 88;
            $('body, html').animate({scrollTop: pos}, 600);
        }
    }

    setInterval(function() {
        var y = $document.scrollTop();
        if (y > 25) {
            $('#header').addClass('scrolled');
        } else {
            $('#header').removeClass('scrolled');
        }
    }, 150);

/*
    // animate numbers

    function animateNumber($selector) {

    	var end_num = parseFloat($selector.attr('data-value'), 10);
    	var decimal = false;

    	if (isNaN(end_num)) {
            end_num = 0;
        }
    	if (end_num % 1 !== 0) {
            decimal = true;
        }

    	$({numberValue: 0}).animate({numberValue: end_num}, {
    		duration: 1000,
    		easing: 'linear',
    		progress: function() {
    			if (decimal) {
                    var num = Math.ceil(this.numberValue*100)/100;
    			} else {
    				var num = Math.ceil(this.numberValue);
    			}
                $selector.text(new Intl.NumberFormat('en-CA', {maximumFractionDigits: 1}).format(num));
    		},
    		complete: function() {
    			var n = parseFloat($selector.text(), 10);
    			if (n !== end_num) {
    				n = end_num;
                    $selector.text(new Intl.NumberFormat('en-CA', {maximumFractionDigits: 1}).format(Math.ceil(end_num)));
    			}
                $selector.addClass('animateNumberDone');
    		}
    	});

    }

    var observer = new MutationObserver(function(mutations) {
        mutations.forEach(function(mutation) {
            if (mutation.attributeName === "class") {
                var $elem = $(mutation.target);
                var attributeValue = $elem.prop(mutation.attributeName);
                if (!$elem.hasClass('animateNumberDone') && $elem.hasClass('aos-animate')) {
                    animateNumber($elem);
                }
            }
        });
    });

    $('.animateNumber').each(function() {
        observer.observe(this, {
            attributes: true
        });
    });

*/

    AOS.init();

});
